import cleanedFilename from '~/util/cleanedFilename';

export default {
  PAGE_CONTAINER: `${cleanedFilename(__filename)}-page-container`,
};
